import { createStyles, makeStyles } from '@material-ui/core'
import { GridCellParams, GridColDef, DataGrid, GridSortDirection, GridValueFormatterParams } from '@material-ui/data-grid'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router'
import { DelaySchema } from '../../../Schema/DelaySchema'
import { formatLocalDateTime } from '../../../Utils/DateFunctions'

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 300,
  },
  /* {
    field: 'isEnabled',
    headerName: 'Enabled?',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridValueFormatterParams) => {
      return (
        <DataGridBoolean params={params} />
      )
    },
  }, */
  {
    field: 'updated',
    headerName: 'Updated',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'updated') as Date)
    },
  },
  {
    field: 'created',
    headerName: 'Created',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'created') as Date)
    },
  },
]

interface CharegeCodesDataGridProps {
  entities: DelaySchema[] | Record<string, DelaySchema>
}

export const CharegeCodesDataGrid: React.FC<CharegeCodesDataGridProps> = ({
  entities,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const [sortModel, setSortModel] = React.useState([
    {
      field: 'name',
      sort: 'asc' as GridSortDirection,
    },
  ])

  const rows: DelaySchema[] = useMemo(() => {
    return _.map(entities)
  }, [entities])

  const handleOnCellClick = (params: GridCellParams) => {
    /* if (_.includes(['status', 'assigneeId'], cellParams.field)) {
      return
    } */
    history.push(`/settings/delays/${params.getValue(params.id, 'id')}`)
  }

  return (
    <DataGrid
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
      className={styles.grid}
      columns={columns}
      rows={rows}
      showColumnRightBorder
      onCellClick={handleOnCellClick}
    />
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    grid: {
      fontSize: 14,
    },
  }),
)
